import {controller, target} from '@github/catalyst'

// Guards the compose → preview → send flow on the purchaser email page. The
// send form carries the *previewed* text in hidden fields, so if staff keep
// typing after previewing, the button would silently send the old version.
// Compare the live fields against what was previewed and gate the button.
@controller
class AnnouncementComposerElement extends HTMLElement {
  @target subject: HTMLInputElement
  @target body: HTMLTextAreaElement
  @target sendButton: HTMLButtonElement | undefined
  @target staleNotice: HTMLElement | undefined

  connectedCallback() {
    this.changed()
  }

  changed() {
    if (!this.sendButton) return

    const previewedSubject = this.getAttribute('data-previewed-subject') ?? ''
    const previewedBody = this.getAttribute('data-previewed-body') ?? ''
    const stale =
      normalize(this.subject.value) !== normalize(previewedSubject) ||
      normalizeBody(this.body.value) !== normalizeBody(previewedBody)

    this.sendButton.disabled = stale
    this.sendButton.classList.toggle('opacity-40', stale)
    this.sendButton.classList.toggle('cursor-not-allowed', stale)
    if (this.staleNotice) this.staleNotice.hidden = !stale
  }
}

// Mirror the server's normalization so an untouched form never reads as stale.
function normalize(value: string): string {
  return value.trim().replace(/\s+/g, ' ')
}

function normalizeBody(value: string): string {
  return value.replace(/\r\n/g, '\n').trim()
}
